import { SiteAbridged } from '../abridged/site-abridged.model';
import { WorkflowItem } from './workflow-item.model';

export class SiteRestrictionWorkflowItem extends WorkflowItem {

  restrictions: string;
  site: SiteAbridged;

  public deserialize(input: any): this {
    super.deserialize(input);

    this.restrictions = input.restrictions;
    this.details = input.restrictions;

    this.site = new SiteAbridged().deserialize(input.site);

    return this;
  }

  public getTaskDetails(): string {
    return `Site Restriction change needs approval on site: ${this.site.name}`;
  }
};
